import { RouteRecordRaw } from 'vue-router';
import { Layout, ParentLayout } from '@/router/constant';
import { DatabaseLink24Regular, TableSettings24Regular, Settings24Regular, ShieldKeyhole24Regular } from '@vicons/fluent';
import { OverflowMenuVertical } from '@vicons/carbon';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/database',
    name: 'database',
    component: Layout,
    // redirect: '/database/config',
    meta: {
      title: 'Database',
      icon: renderIcon(DatabaseLink24Regular),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: ['is_navidata_staff'],
      sort: 11,
    },
    children: [
      {
        path: 'config',
        name: 'database_config',
        redirect: '/database/config',
        component: ParentLayout,
        meta: {
          title: 'Config Tables',
          icon: renderIcon(Settings24Regular),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['is_navidata_staff'],
        },
        children: [
          {
            path: 'resource-config',
            name: 'database_config_resource-config',
            meta: {
              title: 'R-Config',
              spname: 'resource_config',
              icon: renderIcon(TableSettings24Regular),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['is_navidata_staff'],
            },
            component: () => import('@/views/database/config/resource-config/index.vue'),
          },
          {
            path: 'resource-binding-header',
            name: 'database_config_resource-binding-header',
            meta: {
              title: 'B-Header',
              spname: 'resource_binding_header',
              icon: renderIcon(TableSettings24Regular),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['is_navidata_staff'],
            },
            component: () => import('@/views/database/config/resource-binding-header/index.vue'),
          },
          {
            path: 'resource-binding-detail',
            name: 'database_config_resource-binding-detail',
            meta: {
              title: 'B-Detail',
              spname: 'resource_binding_detail',
              icon: renderIcon(TableSettings24Regular),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
      permissions: ['is_navidata_staff'],
            },
            component: () => import('@/views/database/config/resource-binding-detail/index.vue'),
          },
        ],
      },
      {
        path: 'menu-config',
        name: 'database_menu-config',
        redirect: '/database/menu-config',
        component: ParentLayout,
        meta: {
          title: 'Menu Config',
          icon: renderIcon(OverflowMenuVertical),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['is_navidata_staff'],
        },
        children: [
          {
            path: 'actions',
            name: 'database_menu-config_actions',
            meta: {
              title: 'Actions',
              spname: 'menu_leaf_permission',
              icon: renderIcon(TableSettings24Regular),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['is_navidata_staff'],
            },
            component: () => import('@/views/database/menu-config/actions/index.vue'),
          },
          {
            path: 'permissions',
            name: 'database_menu-config_permissions',
            meta: {
              title: 'Permissions',
              spname: 'menu',
              icon: renderIcon(TableSettings24Regular),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['is_navidata_staff'],
            },
            component: () => import('@/views/database/menu-config/permissions/index.vue'),
          },
        ],
      },
      {
        path: 'env-variables',
        name: 'database_env-variables',
        redirect: '/database/env-variables',
        component: ParentLayout,
        meta: {
          title: 'Env Variables',
          icon: renderIcon(ShieldKeyhole24Regular),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          // permissions: ['is_admin'],
        },
        children: [
          {
            path: 'types',
            name: 'database_env-variables_types',
            meta: {
              title: 'Types',
              spname: 'env_type',
              icon: renderIcon(TableSettings24Regular),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['is_navidata_staff'],
            },
            component: () => import('@/views/database/env-variables/types/index.vue'),
          },
          {
            path: 'variables',
            name: 'database_env-variables_variables',
            meta: {
              title: 'Variables',
              spname: 'env_var',
              icon: renderIcon(TableSettings24Regular),
              //配置该路由需要哪些权限可访问 这里是针对单个路由
              permissions: ['is_navidata_staff'],
            },
            component: () => import('@/views/database/env-variables/variables/index.vue'),
          },
        ],
      },
    ],
  },
];

export default routes;
